module.exports = __webpack_public_path__ + "static/media/Ankita Singh.9b717fc9.webp";